import ManageBDX from '@pages/ManageBDX.vue'

export default [
  {
    path: '/manage-bdx',
    name: 'ManageBDX',
    component: ManageBDX,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home'
        }
      ]
    }
  }
]
